import AxiosBase from 'axios';

const Axios = AxiosBase.create({
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
    },
});

Axios.interceptors.request.use((config) => {
    config.params = config.params || {};
    config.params['rest_language'] = document.documentElement.lang.split('-')[0];

    return config;
});

export default Axios;
